import moment from 'moment'
import marked from "marked"

const currency_formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default {
  datetime(value) {
    return moment.parseZone(value).format("ddd MMM D YYYY [at] hh:mm A")
  },

  date(value) {
    return moment(value).format('ddd MMM D')
  },

  standard_date(value) {
    return moment(value).format('YYYY-MM-DD')
  },

  time(value) {
    return moment.parseZone(value).format("hh:mm A")
  },

  time24(value) {
    return moment.parseZone(value).format("HH:mm")  
  },
  
  currency(value) {
    return currency_formatter.format(value)
  },

  decimal(value) {
    return parseFloat(value).toFixed(2);
  },

  markdown(value) {
    return marked(value)
  },

  yes_or_blank(value) {
    return value ? "YES" : "-"
  },

  simpleText(str) {
    if (!str) {
      return ""
    }
    
    str = str.replace(/\r\n?/, "\n");
    str = $.trim(str);
    if (str.length > 0) {
      str = str.replace(/\n\n+/g, '</p><p>');
      str = str.replace(/\n/g, '<br />');
      str = '<p>' + str + '</p>';
    }
    return str;
  }
}